import styled from 'styled-components'
import vars from 'li-components/lib/styles'
import HeaderButton from 'li-components/lib/HeaderButton'
import SvgIcon from 'li-components/lib/SvgIcon'

import { PrimaryLinkStyle } from '../../styled'

const widthWhenOpen = x => p => (p.open ? x : 0)

export const Sidebar = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: none;
  width: ${widthWhenOpen('25%')};
  height: 100vh;
  background-color: white;
  border-left: 1px solid ${vars.grayLighter};
  transition: width 0.25s;
  visibility: ${p => (p.open ? 'visible' : 'hidden')};

  @media (max-width: ${vars.screenMd}) {
    display: block;
    width: ${widthWhenOpen('30%')};
  }

  @media (max-width: ${vars.screenSm}) {
    display: block;
    width: ${widthWhenOpen('60%')};
  }

  @media (max-width: ${vars.screenXs}) {
    display: block;
    width: ${widthWhenOpen('75%')};
  }
`

export const UserSidebar = Sidebar.extend`
  display: block;
`

export const UserSection = styled.section`
  display: flex;
  height: 100%;
  align-items: center;

  > main {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

export const PlatformNavList = styled.ul`
  flex-direction: column;
  padding: 0;
  margin: 0;
  list-style: none;

  .TooltipLink {
    &:hover {
      background-color: transparent;
    }
  }

  li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 5rem;
    padding: 0;
    padding-left: 2rem;
    background-color: white;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: ${vars.grayLightest};
    }
  }

  li a {
    height: auto;
    padding: 0 !important;
    color: ${vars.grayDark};
  }

  .AppLink {
    &.active {
      border: 0;

      a {
        color: ${vars.brandPrimary} !important;
      }
    }

    a {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-top: 0;
      color: ${vars.grayLight};
      font-weight: 700;
    }
  }

  .registerLink {
    /* prettier-ignore */
    ${PrimaryLinkStyle}
  }
`

export const WelcomeNavList = PlatformNavList.extend`
  li a {
    font-weight: 700;
    color: ${vars.grayLight};
  }
`

export const Impersonating = styled.li`
  &.Impersonating {
    display: flex;
    align-items: center;
    padding: 2rem;
    background-color: ${vars.labelInsightPurple};
    color: ${vars.white};
    cursor: pointer;

    &:hover {
      background-color: #d63736;
    }

    svg {
      width: 1.5em;
      height: 1.5em;
      fill: ${vars.white};
    }

    > span {
      margin-left: 1rem;
    }
  }
`

export const BackButton = styled(HeaderButton)`
  margin-right: 1.5rem;
`

export const UserIcon = styled(SvgIcon).attrs({ name: 'user-1' })`
  margin-right: 1.5rem;

  svg {
    fill: ${vars.white};
  }
`



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/SidebarNav/styled.js